import { Controller } from "@hotwired/stimulus";

// First-hover show for Eggy mascot.
// On first mouseenter/touchstart, triggers a 5s "showtime" animation.
// After the show, normal hover animations take over.
// On touch devices, auto-plays the show on page load.

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    this.hasPlayed = false;
    this.isTouchDevice = window.matchMedia("(pointer: coarse) and (hover: none)").matches;

    // Auto-play showtime on touch devices after a short delay
    if (this.isTouchDevice) {
      this.autoPlayTimeout = setTimeout(() => this.enter(), 500);
    }
  }

  enter() {
    if (this.hasPlayed) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    this.hasPlayed = true;
    this.element.classList.add("eggy-mascot--showtime");

    this.timeout = setTimeout(() => {
      this.element.classList.remove("eggy-mascot--showtime");
    }, this.durationValue);
  }

  // Clear sticky :hover on touch devices after the step-forward animation plays
  touchRelease() {
    if (this.releaseTimeout) clearTimeout(this.releaseTimeout);
    this.releaseTimeout = setTimeout(() => {
      const el = this.element;
      el.style.pointerEvents = "none";
      requestAnimationFrame(() => {
        el.style.pointerEvents = "";
      });
    }, 1500);
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.autoPlayTimeout) clearTimeout(this.autoPlayTimeout);
  }
}
